module.exports = __webpack_public_path__ + "static/sportovni-den-2022-02-290efbf7995bf1c4079872a57e520e41.jpg";